module.exports = __webpack_public_path__ + "static/ravi-ae51488f0c1531f8d6831230b69a206c.jpg";